import React from 'react';
import { useLocation } from 'react-router-dom';
import SubWorkspaceDetails from '../Components/SubWorkspaceDetails';
import './pages.css';
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';
import { Helmet } from 'react-helmet-async';

const SubWorkDetails = () => {
  const location = useLocation();
  const root =
    localStorage.getItem('workspace') ??
    location.state?.wname ??
    localStorage.getItem('workspaceName') ??
    'SubWorkspace';
  const parentWorkspaceName = localStorage.getItem('subworkspace') ?? '';
  const parentId = localStorage.getItem('parentWorkspaceId');

  const breadcrumbs: IBreadcrumb[] = [
    {
      name: 'Home',
      href: '/',
      className: 'breadcrumb-link',
    },
    {
      name: 'Workspace',
      href: '/',
      className: 'breadcrumb-link',
    },
    {
      name: root,
      href: parentId ? `/workspace/${parentId}?worksapce=${root}` : '/',
      className: 'breadcrumb-link',
    },
    {
      name: parentWorkspaceName,
      href: ``,
      className: 'breadcrumb-current',
      isCurrent: true,
    },
  ];
  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>{parentWorkspaceName} - SubWorkspace | Silzila</title>
      </Helmet>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <SubWorkspaceDetails />
    </>
  );
};
export default SubWorkDetails;
